import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

import { CurrentUserService } from 'services/currentUser';
import { appendQueryParametersToUrl } from 'utilities/urls';

const module = angular.module('accept-terms-and-conditions', []);

interface AcceptTermsAndConditionController extends angular.IStrictController {
    openCustomerApprovalLink: () => void;
    customerApprovalLink: string;
}

module.component('acceptTermsAndConditions', {
    template: template,
    controller: function(
        this: AcceptTermsAndConditionController,
        $stateParams: PolicyStateParams,
        currentUserService: CurrentUserService
    ) {
        this.$onInit = () => {
            const policyIndex = $stateParams.policyIndex;

            currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                const customerApprovalLink = policyInfo.checkout_data.customer_approval_link;
                this.customerApprovalLink = appendQueryParametersToUrl(customerApprovalLink, {
                    source: 'customer-portal-accept-terms-and-conditions'
                });
            });
        };

        this.openCustomerApprovalLink = () => {
            window.location.replace(this.customerApprovalLink);
        };
    }
});

export { module };
